import { render } from "./CollapseFrame.vue?vue&type=template&id=4e6bbd20&scoped=true"
import script from "./CollapseFrame.vue?vue&type=script&lang=js"
export * from "./CollapseFrame.vue?vue&type=script&lang=js"

import "./CollapseFrame.vue?vue&type=style&index=0&id=4e6bbd20&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6bbd20"]])

export default __exports__